// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderPreview {
  display: flex;
  gap: 10px;
  height: 100%;
  align-items: center;
}
.OrderPreview .embla-thumb {
  flex-basis: 178px;
}
.OrderPreview .embla {
  overflow: hidden;
  max-height: 720px;
  height: calc(100% - 94px);
}
.OrderPreview .embla-container {
  display: flex;
  height: 100%;
}
.OrderPreview .embla-slide {
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  align-items: center;
  background-color: #D3CFE4;
  border-radius: 6px;
  width: 1024px;
  overflow: hidden;
}
.OrderPreview .embla-slide:not(:last-of-type) {
  margin-right: 10px;
}
.OrderPreview .embla-slide .slide-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.OrderPreview .embla-slide .slide-audio-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.OrderPreview .embla-slide .slide-audio {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  width: calc(100% - 20px);
}
.OrderPreview .embla-slide .slide-video {
  width: 100%;
  height: 100%;
}
.OrderPreview .embla-thumb {
  overflow: hidden;
  flex-grow: 1;
}
.OrderPreview .embla-thumb-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 178px;
  touch-action: pan-x;
  height: calc(100% - 40px);
}
.OrderPreview .embla-thumb-wrap {
  max-height: 720px;
  height: calc(100% - 94px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.OrderPreview .embla-thumb-slide {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 10px);
  background-color: #E9E7F2;
  border-radius: 6px;
  overflow: hidden;
  opacity: 0.2;
}
.OrderPreview .embla-thumb-slide:hover:not(.embla-thumb-slide-active) {
  opacity: 0.5;
}
.OrderPreview .embla-thumb-slide .image {
  object-fit: contain;
  height: 100%;
  width: 100%;
}
.OrderPreview .embla-thumb-slide .icon {
  width: 54px;
}
.OrderPreview .embla-thumb-slide-active {
  opacity: 1;
  border: 2px solid #2196F3;
}
.OrderPreview .embla-thumb-btns {
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/views/OrderPreviews/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AACJ;AACI;EACI,iBAAA;AACR;AAEI;EACI,gBAAA;EACA,iBAAA;EACA,yBAAA;AAAR;AAGI;EACI,aAAA;EACA,YAAA;AADR;AAII;EACI,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAFR;AAIQ;EACI,kBAAA;AAFZ;AAKQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AALZ;AAQQ;EACI,WAAA;EACA,YAAA;AANZ;AAUI;EACI,gBAAA;EACA,YAAA;AARR;AAWI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AATR;AAYI;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAVR;AAaI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAAA,cAAA;EAAA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAXR;AAaQ;EACI,YAAA;AAXZ;AAcQ;EACI,mBAAA;EACA,YAAA;EACA,WAAA;AAZZ;AAeQ;EACI,WAAA;AAbZ;AAiBI;EACI,UAAA;EACA,yBAAA;AAfR;AAkBI;EACI,aAAA;EACA,8BAAA;AAhBR","sourcesContent":[".OrderPreview {\n    display: flex;\n    gap: 10px;\n    height: 100%;\n    align-items: center;\n\n    .embla-thumb {\n        flex-basis: 178px;\n    }\n\n    .embla {\n        overflow: hidden;\n        max-height: 720px;\n        height: calc(100% - 94px);\n    }\n\n    .embla-container {\n        display: flex;\n        height: 100%;\n    }\n\n    .embla-slide {\n        display: flex;\n        flex: 0 0 100%;\n        justify-content: center;\n        align-items: center;\n        background-color: #D3CFE4;\n        border-radius: 6px;\n        width: 1024px;\n        overflow: hidden;\n\n        &:not(:last-of-type) {\n            margin-right: 10px;\n        }\n\n        .slide-img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n        }\n\n        .slide-audio-wrap {\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            height: 100%;\n            width: 100%;\n        }\n\n        .slide-audio {\n            position: absolute;\n            bottom: 10px;\n            left: 10px;\n            right: 10px;\n            width: calc(100% - 20px);\n        }\n\n        .slide-video {\n            width: 100%;\n            height: 100%;\n        }\n    }\n\n    .embla-thumb {\n        overflow: hidden;\n        flex-grow: 1;\n    }\n\n    .embla-thumb-container {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 178px;\n        touch-action: pan-x;\n        height: calc(100% - 40px);\n    }\n\n    .embla-thumb-wrap {\n        max-height: 720px;\n        height: calc(100% - 94px);\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n    }\n\n    .embla-thumb-slide {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 calc(25% - 10px);\n        background-color: #E9E7F2;\n        border-radius: 6px;\n        overflow: hidden;\n        opacity: .2;\n\n        &:hover:not(.embla-thumb-slide-active) {\n            opacity: 0.5;\n        }\n\n        .image {\n            object-fit: contain;\n            height: 100%;\n            width: 100%;\n        }\n\n        .icon {\n            width: 54px;\n        }\n    }\n\n    .embla-thumb-slide-active {\n        opacity: 1;\n        border: 2px solid #2196F3;\n    }\n\n    .embla-thumb-btns {\n        display: flex;\n        justify-content: space-between;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
